module.exports = __webpack_public_path__ + "img/cgk.87fbda58.png";